export const safeEval = (code, variables) => {
    const variableEntries = Object.entries(variables);
    const runCode = new Function(...variableEntries.map(([key]) => key), code);
    return runCode(...variableEntries.map(([, val]) => val));
};
//# sourceMappingURL=safe-eval.js.map